import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  VStack,
} from '@chakra-ui/react';
import * as Yup from 'yup';
import { useStores } from '../store/store_context';
import { useNavigate } from 'react-router';

const LoginForm = () => {
  const { pageStore } = useStores();
  const navigate = useNavigate();
  return (
    <Formik
      initialValues={{ username: '', password: '' }}
      validationSchema={Yup.object({
        username: Yup.string().required('Обязательное поле'),
        password: Yup.string().required('Обязательное поле'),
      })}
      onSubmit={async (values, actions) => {
        // Вы можете выполнить здесь запрос к серверу для аутентификации
        try {
          await pageStore.authorize(values);
          if (pageStore.token != null) {
            await pageStore.getMe();
            navigate('/main');
          }
        } catch (error) {
          actions.setFieldError('password', error.message || 'Ошибка входа');
        } finally {
          actions.setSubmitting(false);
        }
      }}
    >
      {formik => (
        <Form>
          <VStack width={'100%'} spacing={5}>
            <Field name="username">
              {({ field, form }) => (
                <FormControl
                  isInvalid={form.errors.username && form.touched.username}
                >
                  <FormLabel htmlFor="username" color={'white'}>
                    Username
                  </FormLabel>
                  <Input
                    {...field}
                    id="username"
                    placeholder="Username"
                    color={'white'}
                  />
                  <FormErrorMessage>{form.errors.username}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Field name="password">
              {({ field, form }) => (
                <FormControl
                  isInvalid={form.errors.password && form.touched.password}
                >
                  <FormLabel htmlFor="password" color={'white'}>
                    Password
                  </FormLabel>
                  <Input
                    {...field}
                    type="password"
                    id="password"
                    placeholder="Password"
                    color={'white'}
                  />
                  <FormErrorMessage>{form.errors.password}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Button
              mt={4}
              isLoading={formik.isSubmitting}
              type="submit"
              width={'100%'}
              color="white"
              backgroundColor={'#4945FF'}
              _hover={{ backgroundColor: '#7B79FF' }}
            >
              Войти
            </Button>
          </VStack>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
